"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventHandlerBufferExtension = eventHandlerBufferExtension;
const iris_rtc_api_type_gen_1 = require("../util/iris_rtc_api_type_gen");
function eventHandlerBufferExtension(func_name, data) {
    var _a;
    let bufferList = [];
    switch (func_name) {
        case iris_rtc_api_type_gen_1.IRTCENGINEEVENTHANDLER_ONSTREAMMESSAGE_99898cb:
            if (data.data) {
                bufferList.push(data.data);
            }
            break;
        case iris_rtc_api_type_gen_1.IAUDIOFRAMEOBSERVER_ONPLAYBACKAUDIOFRAME_4c8de15:
            if ((_a = data === null || data === void 0 ? void 0 : data.audioFrame) === null || _a === void 0 ? void 0 : _a.buffer) {
                bufferList.push(data.audioFrame.buffer);
            }
            break;
    }
    return bufferList;
}
